<div class="organization-information-main-container">
  <section class="top-section">
    <img src="/assets/logo/logo-full-green.png" alt="Logo" class="logo" />
  </section>

<div class="back-home-section">
  <div class="back-button" (click)="back()">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="back-icon">
      <path d="M15.5 18L9.5 12L15.5 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <span class="back-text">Back to home</span>
  </div>
</div>

  <div class="flow-container">
    <div class="form-wrapper">
      <section class="organization-info-container" [formGroup]="organizationForm">
        <h1 class="main-title">Organization Information</h1>
        <p class="subtitle">Enter the Organization Information.</p>

        <!-- Organization Name -->
        <div class="input-container">
          <label class="input-label">Enter your organization name</label>
          <gbui-input
            class="inputs"
            simple
            formControlName="organizationName"
            placeholder="Enter organization name"
          ></gbui-input>
          <label
            class="error-message"
            *ngIf="
              !organizationForm.controls['organizationName'].valid &&
              organizationForm.controls['organizationName'].touched
            "
          >
            Required
          </label>
        </div>

        <!-- Industry Dropdown -->
        <!-- <div class="input-container">
          <label class="input-label">Select Industry (Optional)</label>
          <div class="custom-select-wrapper">
            <div 
              class="custom-select-header"
              (click)="toggleIndustryDropdown()"
              tabindex="0"
              (keydown.enter)="toggleIndustryDropdown()"
              (keydown.space)="toggleIndustryDropdown()"
            >
            <span class="selected-value">
  {{ organizationForm.get('industry')?.value ? getDisplayIndustryName(organizationForm.get('industry')?.value) : (industriesLoading ? 'Loading...' : 'Select an industry') }}
</span>
              <svg class="dropdown-arrow" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M6 9L1 4h10z" fill="#0a3731"/>
              </svg>
            </div>
            <div class="custom-select-dropdown" *ngIf="showIndustryDropdown">
              <div class="dropdown-option" (click)="selectIndustry(null)">Select an industry</div>
              <ng-container *ngIf="!industriesLoading">
                <div 
                  class="dropdown-option"
                  *ngFor="let ind of industries"
                  (click)="selectIndustry(ind?.id ?? ind?.value ?? ind?.name ?? ind)"
                  [class.selected]="(organizationForm.get('industry')?.value) === (ind?.id ?? ind?.value ?? ind?.name ?? ind)"
                >
                  {{ formatIndustryName(ind?.name ?? ind?.label ?? ind?.value ?? ind) }}
                </div>
              </ng-container>
            </div>
          </div>
        </div> -->

        <!-- City -->
        <!-- <div class="input-container">
          <label class="input-label">City</label>
          <gbui-input
            class="inputs"
            simple
            formControlName="city"
            placeholder="Enter city"
          ></gbui-input>
          <label
            class="error-message"
            *ngIf="
              !organizationForm.controls['city'].valid &&
              organizationForm.controls['city'].touched
            "
          >
            Required
          </label>
        </div> -->

        <!-- State -->
        <!-- <div class="input-container">
          <label class="input-label">State</label>
          <gbui-input
            class="inputs"
            simple
            formControlName="state"
            placeholder="Enter state"
          ></gbui-input>
          <label
            class="error-message"
            *ngIf="
              !organizationForm.controls['state'].valid &&
              organizationForm.controls['state'].touched
            "
          >
            Required
          </label>
        </div> -->

        <!-- Zip Code -->
        <!-- <div class="input-container">
          <label class="input-label">Zip Code</label>
          <gbui-input
            class="inputs"
            simple
            formControlName="zipCode"
            placeholder="Enter zip code"
          ></gbui-input>
          <label
            class="error-message"
            *ngIf="
              !organizationForm.controls['zipCode'].valid &&
              organizationForm.controls['zipCode'].touched
            "
          >
            Required
          </label>
        </div> -->

        <!-- Country -->
        <!-- <div class="input-container">
          <label class="input-label">Country</label>
          <gbui-input
            class="inputs"
            simple
            formControlName="country"
            placeholder="Enter country"
          ></gbui-input>
          <label
            class="error-message"
            *ngIf="
              !organizationForm.controls['country'].valid &&
              organizationForm.controls['country'].touched
            "
          >
            Required
          </label>
        </div> -->

        <!-- Submit Button -->
        <gbui-button
          (click)="saveInformation()"
          [disabled]="organizationForm.invalid"
          class="save-button"
          type="button"
        >
          Save Information and Proceed
        </gbui-button>
      </section>
    </div>
  </div>
</div>
